module.exports = __webpack_public_path__ + "img/kuaiyufushi-hover.f4ce7ec5.png";